import {Component} from "@angular/core";

import {PacService} from 'src/app/services/pac.service';
import {DocumentoPac} from 'src/app/model/DocumentoPac';
import {Router} from "@angular/router";
import {PesquisaPacStateService} from "src/app/services/pesquisa-pac.state.service";

@Component({
  selector: 'pesquisa-pac',
  templateUrl: './pesquisa-pac.component.html',
  styleUrls: ['./pesquisa-pac.component.scss'],
  standalone: false
})
export class PesquisaPacComponent {

  exibePesquisaAvancada: boolean;
  pacs: DocumentoPac[];
  msg: string;

  // Critério básico
  criterio: string;
  // Critérios Avançados
  criterioProposta: string;
  criterioAno: number;
  criterioPac: string;
  criterioComprador: string;

  constructor(
    private service: PacService,
    private router: Router,
    private state: PesquisaPacStateService,
  ) {
  }

  ngOnInit(): void {
    this.msg = "Faça uma pesquisa acima";
    //this.pesquisar();
    this.state.state$.subscribe(
      s => {
        this.exibePesquisaAvancada = s.exibePesquisaAvancada;
        this.pacs = [...s.pacs];
        this.criterio = s.criterio;
        this.criterioProposta = s.criterioProposta;
        this.criterioAno = s.criterioAno;
        this.criterioPac = s.criterioPac;
        this.criterioComprador = s.criterioComprador;

        this.msg = this.pacs?.length ? null : "Faça uma pesquisa acima";
      })
  }

  pesquisar() {
    this.msg = "...";
    if (this.exibePesquisaAvancada) {
      this.service.pesquisaPacAvancada(this.criterioProposta, this.criterioAno, this.criterioPac, this.criterioComprador).subscribe(c => {
        this.pacs = c.list;
        this.msg = null;
        this.state.update({
          exibePesquisaAvancada: this.exibePesquisaAvancada,
          pacs: this.pacs,
          criterioProposta: this.criterioProposta,
          criterioAno: this.criterioAno,
          criterioPac: this.criterioPac,
          criterioComprador: this.criterioComprador
        });
      });
    } else {
      this.service.pesquisaPac(this.criterio).subscribe(c => {
        this.pacs = c.list;
        this.msg = null;
        this.state.update({
          exibePesquisaAvancada: this.exibePesquisaAvancada,
          criterio: this.criterio,
          pacs: this.pacs,
        })
      });
    }
  }

  alternarPesquisa() {
    this.exibePesquisaAvancada = !this.exibePesquisaAvancada;
  }

  onVisualizarClick(pac: DocumentoPac) {
    this.router.navigate(["/envio-aditivo/" + pac.id]);
  }
}
